<div *ngIf="heeftOndernemingen()">
    <form [formGroup]="specJaarrekeningFg">
        <div formArrayName="specificatieJaarrekening">
            <div *ngFor="let spec of specificatieJaarrekening.controls; let i = index "
                 [formGroupName]="i">
                <div formGroupName="opbouw">

                    <div class="row">
                        <div class="col col-1">
                            @if (!heeftSamenwerkingsverband) {
                                <p>Winst volgens resultatenrekening</p>
                            } @else {
                                <p>Winstaandeel samenwerkingsverband</p>
                            }
                        </div>
                        <div class="col-2">
                            @if (!heeftSamenwerkingsverband) {
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        [disabledControl]="true"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="winstVolgensResultatenRekening"
                                        id="winstVolgensResultatenRekening"
                                        prefix="€">
                                </snelstart-ui-number-form-control>
                            } @else {
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        [disabledControl]="true"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="aandeelInWinstVolgensResultatenRekening"
                                        id="aandeelInWinstVolgensResultatenRekening"
                                        prefix="€">
                                </snelstart-ui-number-form-control>
                            }
                        </div>
                        <div class="col-4"></div>
                        <div class="col-4"></div>
                    </div>

                    <div *ngIf="this.specJaarrekeningFg.get('specificatieJaarrekening.0.opbouw.benutteKIA')?.value > 0"
                         class="row">
                        <div class="col col-1">
                            <p>Af: Kleinschaligheidsinvesteringsaftrek</p>
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [disabledControl]="true"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="benutteKIA"
                                    id="benutteKIA"
                                    prefix="€ -">
                            </snelstart-ui-number-form-control>
                        </div>
                        <div class="col-4"></div>
                        <div class="col-4"></div>
                    </div>

                    <div *ngIf="this.specJaarrekeningFg.get('specificatieJaarrekening.0.opbouw.benutteMIA')?.value > 0"
                         class="row">
                        <div class="col col-1">
                            <p>Af: Milieu-investeringsaftrek</p>
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [disabledControl]="true"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="benutteMIA"
                                    id="benutteMIA"
                                    prefix="€ -">
                            </snelstart-ui-number-form-control>
                        </div>
                        <div class="col-4"></div>
                        <div class="col-4"></div>
                    </div>

                    <div *ngIf="this.specJaarrekeningFg.get('specificatieJaarrekening.0.opbouw.benutteEIA')?.value > 0"
                         class="row">
                        <div class="col col-1">
                            <p>Af: Energie-investeringsaftrek</p>
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [disabledControl]="true"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="benutteEIA"
                                    id="benutteEIA"
                                    prefix="€ -">
                            </snelstart-ui-number-form-control>
                        </div>
                        <div class="col-4"></div>
                        <div class="col-4"></div>
                    </div>

                    <div *ngIf="this.specJaarrekeningFg.get('specificatieJaarrekening.0.opbouw.totaleDIB')?.value > 0"
                         class="row">
                        <div class="col col-1">
                            <p>Bij: Desinvesteringsbijtelling</p>
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [disabledControl]="true"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="totaleDIB"
                                    id="totaleDIB"
                                    prefix="€">
                            </snelstart-ui-number-form-control>
                        </div>
                        <div class="col-4"></div>
                        <div class="col-4"></div>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <form [formGroup]="specWUOFormGroup">
        <div class="row">
            <div formGroupName="specificatieWUO">
                <div formGroupName="opbouw">
                    <div *ngIf="this.isDefAangifte">
                        <div *ngIf="specWUOFormGroup.get('specificatieWUO.opbouw.vrijgesteldeWinst')?.value > 0"
                             class="row">
                            <div class="col col-1">
                                <p>Af: Vrijgestelde winst</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control [decimals]="0"
                                                                  [disabledControl]="true"
                                                                  align="right"
                                                                  class="custom-input-150"
                                                                  formControlName="vrijgesteldeWinst"
                                                                  id="vrijgesteldeWinst"
                                                                  prefix="-">
                                </snelstart-ui-number-form-control>
                            </div>
                            <div class="col-4"></div>
                            <div class="col-4"></div>
                        </div>

                        <div class="row">
                            <div class="col col-2">
                                <p>Bij: Niet en/of deels aftrekbare kosten</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="totaleNietAftrekbareKosten"
                                        id="totaleNietAftrekbareKosten"
                                        prefix="€">
                                </snelstart-ui-number-form-control>
                            </div>
                            <div class="col-4"></div>
                            <div class="col-4"></div>
                        </div>

                        <div *ngIf="specWUOFormGroup.get('specificatieWUO.opbouw.mutatieReserves')?.value !== 0"
                             class="row">
                            <div *ngIf="specWUOFormGroup.get('specificatieWUO.opbouw.mutatieReserves')?.value < 0"
                                 class="col col-1">
                                <p>Af: Wijzigingen in toelaatbare reserves</p>
                            </div>
                            <div *ngIf="specWUOFormGroup.get('specificatieWUO.opbouw.mutatieReserves')?.value > 0"
                                 class="col col-1">
                                <p>Bij: Wijzigingen in toelaatbare reserves</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="mutatieReserves"
                                        id="mutatieReserves"
                                        prefix="€">
                                </snelstart-ui-number-form-control>
                            </div>
                            <div class="col-4"></div>
                            <div class="col-4"></div>
                        </div>
                    </div>

                    <div *ngIf="!this.isDefAangifte">

                        <div class="row">
                            <div class="col col-1">
                                <p>Bij: Winstpost</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="totaleNietAftrekbareKosten"
                                        id="bijtelpost"
                                        prefix="€">
                                </snelstart-ui-number-form-control>
                            </div>
                            <div class="col-4"></div>
                            <div class="col-4"></div>
                        </div>

                        <div class="row">
                            <div class="col col-1">
                                <p>Af: Aftrekpost</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="vrijgesteldeWinst"
                                        id="aftrekpost"
                                        prefix="€ -">
                                </snelstart-ui-number-form-control>
                            </div>
                            <div class="col-4"></div>
                            <div class="col-4"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <form [formGroup]="specWUOFormGroup">
        <div formGroupName="specificatieWUO">
            <div formGroupName="opbouw">
                <div class="row">
                    <div class="col col-1">
                        <p>Fiscale winst voor ondernemersaftrek</p>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                [disabledControl]="true"
                                align="right"
                                class="custom-input-150"
                                formControlName="winstVoorOndernemersaftrek"
                                id="winstvoorOndernemersaftrek"
                                prefix="€">
                        </snelstart-ui-number-form-control>
                    </div>
                    <div class="col-4"></div>
                </div>
            </div>
        </div>
    </form>


    <form [formGroup]="specWUOFormGroup">
        <div class="row">
            <div formGroupName="specificatieWUO">
                <div formGroupName="opbouw">
                    <div *ngIf="specWUOFormGroup.get('specificatieWUO.opbouw.zelfstandigenaftrek')?.value > 0"
                         class="row">
                        <div class="col col-1">
                            Af: Zelfstandigenaftrek
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="zelfstandigenaftrek"
                                    id="zelfstandigenaftrek"
                                    placeholder="-"
                                    prefix=" € "
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-4"></div>
                        <div class="col-4"></div>
                    </div>

                    <div *ngIf="specWUOFormGroup.get('specificatieWUO.opbouw.zelfstandigenaftrekVoorAOWer')?.value > 0"
                         class="row">
                        <div class="col col-1">
                            Af: Zelfstandigenaftrek voor AOW-er
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="zelfstandigenaftrekVoorAOWer"
                                    id="zelfstandigenaftrekVoorAOWer"
                                    prefix=" €"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-4"></div>
                        <div class="col-4"></div>
                    </div>

                    <div *ngIf="specWUOFormGroup.get('specificatieWUO.opbouw.startersaftrek')?.value > 0" class="row">
                        <div class="col col-1">
                            Af: Startersaftrek
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="startersaftrek"
                                    id="startersaftrek"
                                    prefix=" € "
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-4"></div>
                        <div class="col-4"></div>
                    </div>

                    <div *ngIf="specWUOFormGroup.get('specificatieWUO.opbouw.startersaftrekAO')?.value > 0" class="row">
                        <div class="col col-1">
                            Af: Startersaftrek bij arbeidsongeschiktheid
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="startersaftrekAO"
                                    id="startersaftrekAO"
                                    prefix=" € "
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-4"></div>
                        <div class="col-4"></div>
                    </div>

                    <div *ngIf="specWUOFormGroup.get('specificatieWUO.opbouw.meewerkaftrek')?.value > 0" class="row">
                        <div class="col col-1">
                            Af: Meewerkaftrek
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="meewerkaftrek"
                                    id="meewerkaftrek"
                                    prefix=" € "
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-4"></div>
                        <div class="col-4"></div>
                    </div>

                    <div *ngIf="specWUOFormGroup.get('specificatieWUO.opbouw.stakingsaftrek')?.value > 0" class="row">
                        <div class="col col-1">
                            Af: Stakingsaftrek
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="stakingsaftrek"
                                    id="stakingsaftrek"
                                    prefix=" € "
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-4"></div>
                        <div class="col-4"></div>
                    </div>

                    <div *ngIf="specWUOFormGroup.get('specificatieWUO.opbouw.senoaftrek')?.value > 0" class="row">
                        <div class="col col-1">
                            Af: Aftrek voor speur- en ontwikkelingswerk
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="senoaftrek"
                                    id="senoaftrek"
                                    prefix=" €"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-4"></div>
                        <div class="col-4"></div>
                    </div>

                    <div class="row">
                        <div *ngIf="specWUOFormGroup.get('specificatieWUO.opbouw.ondernemersaftrek')?.value === 0"
                             class="col col-1">
                            Af: Ondernemersaftrek
                        </div>
                        <div *ngIf="specWUOFormGroup.get('specificatieWUO.opbouw.ondernemersaftrek')?.value > 0"
                             class="col col-1">
                            Totaal ondernemersaftrek
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="ondernemersaftrek"
                                    id="oa"
                                    placeholder="-"
                                    prefix=" € -"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-4"></div>
                    </div>

                    <div *ngIf="specWUOFormGroup.get('specificatieWUO.opbouw.restant')?.value > 0" class="row">
                        <div class="col col-1">
                            Af: Restant zelfstandigenaftrek voorgaande jaren
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="restant"
                                    id="restant"
                                    placeholder="-"
                                    prefix=" € -"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-4"></div>
                    </div>

                    <div class="row">
                        <div class="col col-1">
                            <p>Fiscale winst na ondernemersaftrek</p>
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="fiscaleWinstMinusOA"
                                    id="fiscaleWinstMinusOA"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-4"></div>
                    </div>

                    <div class="row">
                        <div class="col col-1">
                            <div *ngIf="this.incomeTaxEntity.aangifte?.aangifteJaar === 2024">
                                Mkb-winstvrijstelling: 13,31% van
                                € {{ specWUOFormGroup.get('specificatieWUO.opbouw.fiscaleWinstMinusOA')?.value | number: '1.0-0' }}
                            </div>
                            <div *ngIf="this.incomeTaxEntity.aangifte?.aangifteJaar === 2025">
                                Mkb-winstvrijstelling: 12,7% van
                                € {{ specWUOFormGroup.get('specificatieWUO.opbouw.fiscaleWinstMinusOA')?.value | number: '1.0-0' }}
                            </div>
                            <div *ngIf="this.incomeTaxEntity.aangifte?.aangifteJaar === 2026">
                                Mkb-winstvrijstelling: 12,7% van
                                € {{ specWUOFormGroup.get('specificatieWUO.opbouw.fiscaleWinstMinusOA')?.value | number: '1.0-0' }}
                            </div>
                        </div>
                        <div class="col-2">
                            <div *ngIf="this.specWUOFormGroup.get('specificatieWUO.opbouw.fiscaleWinstMinusOA')?.value >=0">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="mkbWinstvrijstelling"
                                        id="mkbWinstvrijstelling"
                                        prefix="€ -"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div *ngIf="this.specWUOFormGroup.get('specificatieWUO.opbouw.fiscaleWinstMinusOA')?.value < 0">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="mkbWinstvrijstelling"
                                        id="mkbWinstvrijstelling"
                                        prefix="€ "
                                ></snelstart-ui-number-form-control>
                            </div>
                        </div>
                        <div class="col-4"></div>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <form [formGroup]="specBelWinstFormGroup">
        <div formGroupName="specificatieInkomenBox1">
            <div formGroupName="opbouw">
                <div class="row">
                    <div *ngIf="!this.partnerBoolean" class="col col-1" style="font-weight: bold">
                        <p>Belastbare winst {{ dataService.naamAangever }}</p>
                    </div>
                    <div *ngIf="this.partnerBoolean" class="col col-1" style="font-weight: bold">
                        <p>Belastbare winst {{ dataService.naamPartner }}</p>
                    </div>
                    <div class="col-2">

                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="winstUitOnderneming"
                                id="winstUitOnderneming"
                                prefix="€"
                        ></snelstart-ui-number-form-control>

                    </div>
                    <div class="col-4"></div>
                </div>
            </div>
        </div>
    </form>

</div>

<div *ngIf="!heeftOndernemingen()">
    <div *ngIf="!partnerBoolean">
        Er is geen onderneming voor {{ dataService.naamAangever }} ingevuld.
    </div>

    <div *ngIf="partnerBoolean">
        Er is geen onderneming voor {{ dataService.naamPartner }} ingevuld.
    </div>
</div>


